import { actRequest } from "./request/request"
import { RESP } from "./request"

export type TaskStatusItem = {
    cid: string
    /** 0=初始 | 10=达成待领取 | 20=已完成 */
    status: 0 | 10 | 20
    progress?: { value: number } | null
}

export type CouponResult = {
    giftName: string
    prizeId: string
    prizeType: string
}

export type CouponItem = {
    cid: string
    name: string
    rarity: number
    /** 0=可用 | 2=已使用 | 3=失败 */
    status: 0 | 2 | 3
    result: CouponResult | null
}

export type ContactInfo = {
    name: string
    phone: string
    address: string
    email?: string
    postcode?: string
    province?: string
    city?: string
    county?: string
}

export type TeamMember = {
    uid: string
    nickname: string | null
    avatar: null
}

/** 获取活动元信息：GET /meta */
export const requestGetMeta = async () => {
    return actRequest.get<null, RESP<{
        cid: string
        game: string
        template: string
        tasks: {
            cid: string
            order: number
            template: string
            templateParams: Record<string, unknown> | null
        }[]
    }>>("/meta")
}

/** 同步任务状态：POST /task */
export const requestSyncTask = async () => {
    return actRequest.post<null, RESP<TaskStatusItem[]>>("/task")
}

/** 领取任务奖励：POST /task/{taskCid}/complete */
export const requestCompleteTask = async (taskCid: string) => {
    return actRequest.post<null, RESP<Record<string, never>>>(
        `/task/${taskCid}/complete`,
    )
}

/** 查询抽奖状态：GET /draw */
export const requestGetDraw = async () => {
    return actRequest.get<
        null,
        RESP<{
            coupons: CouponItem[]
            contactInfo: Record<string, ContactInfo | null>
        }>
    >("/draw")
}

/** 执行抽奖：POST /draw */
export const requestPostDraw = async (coupon: string) => {
    return actRequest.post<
        null,
        RESP<{
            giftName: string
            prizeId: string
            prizeType: string
        }>
    >("/draw", { coupon })
}

/** 填写实物收货地址：POST /draw/contact */
export const requestPostContact = async (coupon: string, info: ContactInfo) => {
    return actRequest.post<null, RESP<Record<string, never>>>(
        "/draw/contact",
        { coupon, ...info },
    )
}

/** 获取/创建自己的队伍：POST /team/sync */
export const requestTeamSync = async () => {
    return actRequest.post<
        null,
        RESP<{
            code: string
            captain: TeamMember
            member: TeamMember | null
        }>
    >("/team/sync")
}

/** 用邀请码查询队伍信息：GET /team/search?code= */
export const requestTeamSearch = async (code: string) => {
    return actRequest.get<
        null,
        RESP<{
            code: string
            captain: TeamMember
            // captainUid: string
            // captainNickname: string | null
        }>
    >("/team/search", { params: { code } })
}

/** 加入队伍：POST /team/join */
export const requestTeamJoin = async (code: string) => {
    return actRequest.post<null, RESP<Record<string, never>>>("/team/join", {
        code,
    })
}

/** 获取自己加入的队伍：GET /team/joined */
export const requestTeamJoined = async () => {
    return actRequest.get<null, RESP<Record<string, unknown> | null>>(
        "/team/joined",
    )
}
